import ArtistAuctionRecords from "./ArtistAuctionRecords";
export default ArtistAuctionRecords;
